function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.089 3.651c1.056-1.936 2.77-1.93 3.823 0l7.01 12.851c1.056 1.936.12 3.505-2.087 3.505H5.166c-2.208 0-3.14-1.575-2.087-3.505l7.01-12.85zm2.814 6.43V7.368h-1.805v2.713l.463 4.35h.868l.474-4.35zm-.076 7.218v-1.865h-1.642v1.865h1.642z",
    fill: "#000",
    fillRule: "evenodd"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-alert.svg";